import styled from 'styled-components';

const LoginStyled = styled.div`
    align-items: center;
    background-color: white;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 90px auto 0 auto;
    max-width: 800px;
    padding: 0 20px;
    position: relative;
    width: 100%;
    ${({ theme }) => theme.media.down('md')`
        margin: 60px auto 0 auto;
    `};
`;

export default LoginStyled;
